export const skSK = {
  app: {
    categories: {
      convectors: 'Konvektory',
      decorative: 'Dekoratívne',
      electric: 'Elektrické',
      panels: 'Panely',
      towel: 'Sušiaky uterákov',
    },
    categoryLabel: 'Kategória',
    categoryPlaceholder: 'Vyberte kategóriu',
    errorCategories: 'Nepodarilo sa načítať kategórie.',
    errorPanels: 'Nepodarilo sa načítať radiátory.',
    loadingCategories: 'Načítavanie kategórií...',
    loadingPanels: 'Načítavanie radiátorov...',
    panelLabel: 'Radiátory',
    panelPlaceholder: 'Vyberte radiátor',
    titles: {
      convectors: 'Kalkulačka konvektorov',
      decorative: 'Kalkulačka dizajnových radiátorov',
      electric: 'Kalkulačka elektrických radiátorov',
      panels: 'Kalkulačka panelových radiátorov',
      towel: 'Kalkulačka sušiakov uterákov',
    },
  },
  calc: {
    actionButton: 'Zobraziť vypočítané položky',
    boost: 'Turbo režim',
    calculateRequiredButton: 'Vypočítať požadované watty',
    calculating: 'Počítanie...',
    comfort: 'Komfortný režim',
    downloadLabel: 'Stiahnuť dáta ({count})',
    emptyResults: 'Zatiaľ žiadne výsledky.',
    errorMatch: 'Nepodarilo sa vypočítať výsledky.',
    errorTypes: 'Nepodarilo sa načítať typy radiátorov.',
    flowTemp: 'Teplota prívodu C°',
    height: 'Výška',
    length: 'Dĺžka',
    loadingTypes: 'Načítavanie typov...',
    modeLabel: 'Režim',
    modes: {
      cooling: 'Chladenie',
      heating: 'Kúrenie',
    },
    radiatorType: 'Typ radiátora',
    requiredWatts: 'Požadované watty',
    resultsMessage: '{count} položiek dostupných pre vybrané nastavenia.',
    returnTemp: 'Teplota spiatočky C°',
    roomTemp: 'Teplota miestnosti C°',
    selectAllLabel: 'Vybrať všetky položky',
    selectItemLabel: 'Vyberte položku na stiahnutie',
    selectPanel: 'Vyberte radiátor na výpočet.',
    standby: 'Pohotovostný režim',
    tableHeaders: {
      calculatedWattage: 'Watty',
      co2Equivalent: 'CO2 ekvivalent na kg materiálu',
      depth: 'Hĺbka [mm]',
      description: 'Popis položky',
      dop: 'DOP',
      eudop: 'EU DOP',
      height: 'Výška [mm]',
      itemId: 'Kód položky',
      length: 'Dĺžka [mm]',
      waterContent: 'Obsah vody',
      weight: 'Hmotnosť',
    },
    title: 'Výpočty',
    tolerance: 'Tolerancia',
    typeCooling: 'Chladenie',
    typeGroupLabel: 'Typ',
    typeHeating: 'Kúrenie',
  },
  existingRadiator: {
    description:
      'Táto kalkulačka je iba informatívna. Pred kúpou radiátora vždy konzultujte presný výpočet s odborným inštalatérom.',
    height: 'Výška radiátora',
    length: 'Dĺžka radiátora',
    resultLabelTemplate: 'Požadovaný tepelný výkon, vypočítaný pri teplote systému {temp}',
    select: 'Vybrať',
    temperature: 'Teplota systému',
    type: 'Typ radiátora',
  },
  matrixCalc: {
    axisHeight: 'Výška (mm)',
    axisLength: 'Dĺžka (mm)',
    axisType: 'Typ',
    calculateButton: 'Calculate',
    displayLabel: 'Zobrazenie',
    exportExcel: 'Exportovať do Excelu',
    exportPdf: 'Exportovať do PDF',
    print: 'Tlač',
    hideOutOfRange: 'Skryť položky mimo rozsahu',
    showAll: 'Zobraziť všetko',
    loading: 'Loading...',
    lockHeight: 'Výška',
    lockLabel: 'Zamknúť rozmer',
    lockLength: 'Dĺžka',
    lockType: 'Typ',
    noData: 'Select a radiator and click Calculate to view the matrix.',
    noItem: '—',
    noType: '—',
    targetOutput: 'Target output (W)',
    title: 'Matrix Calculator',
    tolerance: 'Tolerance (%)',
  },
  roomCalc: {
    actionButton: 'Vypočítať',
    clearButton: 'Vymazať všetko',
    fields: {
      ceilingHeight: 'Výška stropu',
      doorInsulation: 'Izolácia dverí',
      floorInsulation: 'Izolácia podlahy',
      glazingArea: 'Plocha zasklenia',
      glazingMode: 'Plocha zasklenia',
      glazingQuality: 'Kvalita zasklenia',
      length: 'Dĺžka',
      outerWalls: 'Vonkajšie steny',
      projectedDesignTemp: 'Návrhová vonkajšia teplota (NVT) v mieste stavby',
      roofInsulation: 'Izolácia strechy',
      roomArea: 'Plocha miestnosti',
      roomFloor: 'Podlažie',
      roomInsulation: 'Izolácia miestnosti',
      roomPreset: 'Typ miestnosti',
      roomTemperature: 'Teplota miestnosti',
      roomType: 'Typ miestnosti',
      uncertaintyFactor: 'Faktor neistoty',
      ventilation: 'Úroveň vetrania',
      wallInsulation: 'Izolácia stien',
      width: 'Šírka',
      windConditions: 'Veterné podmienky',
      windowInsulation: 'Izolácia okien',
    },
    intro:
      'Vypočítajte tepelné straty miestnosti a vyberte správny produkt z našej ponuky radiátorov.',
    options: {
      glazing: {
        m2: 'm²',
        percent: '%',
      },
      glazingBands: {
        high: 'Viac ako 20%',
        low: 'Menej ako 10%',
        mid: '10-20%',
      },
      glazingValue: {
        above_20: 'Nad 20%',
        below_10: 'Pod 10%',
        from_10_to_20: 'Od 10% do 20%',
        no_windows: 'Bez okien',
      },
      insulationValue: {
        good: 'Dobrá',
        medium: 'Stredná',
        poor: 'Slabá',
        very_good: 'Veľmi dobrá',
      },
      qualityValue: {
        modern_excellent: 'Moderné, výborná energetická účinnosť',
        modern_good: 'Moderné, dobrá energetická účinnosť',
        old_poor: 'Staré, veľmi slabá energetická účinnosť',
        traditional_medium: 'Tradičné, stredná energetická účinnosť',
      },
      roomValue: {
        bathroom_24: 'Kúpeľňa (24 C°)',
        bedroom_20: 'Spálňa (20 C°)',
        garage_12: 'Garáž (12 C°)',
        livingroom_22: 'Obývacia izba (22 C°)',
        storage_16: 'Sklad (16 C°)',
      },
      select: 'Vybrať',
      storeyValue: {
        ground_multi: 'Prízemie (viacpodlažná budova)',
        ground_single: 'Prízemie (jednopodlažná budova)',
        interim: 'Stredné podlažie',
        top_multi: 'Najvyššie podlažie (viacpodlažná budova)',
      },
      temp: {
        climate_zone_1: 'NVT -12 C°',
        climate_zone_2: 'NVT -14 C°',
        climate_zone_3: 'NVT -16 C°',
        climate_zone_4: 'NVT -18 C°',
        climate_zone_5: 'NVT -20 C°',
        climate_zone_6: 'NVT -22 C°',
        climate_zone_7: 'NVT -24 C°',
        climate_zone_8: 'NVT -26 C°',
      },
      windInfluence: {
        normal: 'Normálne',
        strong: 'Silné',
        weak: 'Slabé',
      },
    },
    roomPresets: {
      bathroom: 'Kúpeľňa',
      bedroom: 'Spálňa',
      garage: 'Garáž',
      kitchen: 'Kuchyňa',
      living: 'Obývacia izba',
      storage: 'Sklad',
    },
    sections: {
      dimensions: 'Rozmery miestnosti',
      insulation: 'Izolácia',
      placement: 'Umiestnenie',
      result: 'Výsledok',
      temps: 'Teploty',
      ventilation: 'Vetranie',
    },
    title: 'Kalkulačka tepelných strát',
    units: {
      celsius: 'C°',
      meter: 'm',
      percent: '%',
      squareMeter: 'm²',
      watts: 'W',
    },
    useButton: 'Použiť',
  },
  slider: {
    from: 'Od',
    to: 'Do',
    value: 'Hodnota',
  },
}
